import { useCallback } from "react"
import { useTranslations } from "next-intl"
import { type ErrorIntlConfig } from "../types/errorIntlConfig"
import { type Namespace } from "../types/namespace"

type CreateUseFormatErrorCodeConfig<TMessages, TNamespace extends Namespace<TMessages>> = Pick<
    ErrorIntlConfig<TMessages, TNamespace>,
    "namespace" | "formatErrorCode"
>

export function createUseFormatErrorCode<TMessages, TNamespace extends Namespace<TMessages>>({
    namespace,
    formatErrorCode,
}: CreateUseFormatErrorCodeConfig<TMessages, TNamespace>) {
    function useFormatErrorCode() {
        const t = useTranslations(namespace)

        return useCallback(
            (errorCode: string) => {
                return formatErrorCode({ t, errorCode })
            },
            [t]
        )
    }

    useFormatErrorCode.messages = [namespace] as const

    return useFormatErrorCode
}
